import { useTranslation } from "react-i18next";
import { useProfile } from "../../../api/profile";
import { Header } from "../../Header";
import { PageTour } from "../../tour/PageTour";
import { profileTourSteps } from "../../tour/steps/pageSteps";
import { ProfileAccountTab } from "./ProfileAccountTab";
import { PROFILE_NAV_ITEMS, ProfileTabId } from "./profileNav";
import { ProfilePrivacyTab } from "./ProfilePrivacyTab";
import { ProfileSecurityTab } from "./ProfileSecurityTab";

export const ProfilePage = ({ tab }: { tab: ProfileTabId }) => {
  const { t } = useTranslation();
  const { profileData, isLoading, error, setProfileData } = useProfile();

  // Toujours trouve : `tab` est un ProfileTabId, et chaque id a son entree.
  const page =
    PROFILE_NAV_ITEMS.find((item) => item.id === tab) ?? PROFILE_NAV_ITEMS[0];

  const renderPanel = () => {
    if (tab === "privacy") return <ProfilePrivacyTab />;

    if (isLoading) {
      // Squelette plutot qu'un « Chargement... » nu : la page ne saute pas au rendu.
      return (
        <div className="flex flex-col lg:flex-row lg:justify-center gap-4 animate-pulse">
          <div className="w-full lg:w-72 h-72 shrink-0 bg-grey-light rounded-lg" />
          <div className="w-full max-w-3xl space-y-4">
            <div className="h-64 bg-grey-light rounded-lg" />
            <div className="h-64 bg-grey-light rounded-lg" />
          </div>
        </div>
      );
    }

    if (error || !profileData) {
      return (
        <div className="p-4 bg-red-50 border border-red-200 text-red-700 rounded-lg">
          {error ?? t("profile-unavailable")}
        </div>
      );
    }

    return tab === "security" ? (
      <ProfileSecurityTab accountId={profileData.account.id} />
    ) : (
      <ProfileAccountTab
        profileData={profileData}
        onProfileUpdate={setProfileData}
      />
    );
  };

  return (
    <div className="p-2 md:p-4">
      <Header
        title={t(page.label)}
        icon={page.icon}
        help={<PageTour id="profile" steps={profileTourSteps} />}
      />

      <div className="mt-4">{renderPanel()}</div>
    </div>
  );
};
